import { IP } from "@modules/network/@types/IP";
import NetworkThreatCard from "@modules/network/components/cards/NetworkThreatCard";
import CardTitle from "@modules/network/components/common/CardTitle";
import IocTable from "@modules/network/ThreatIntel/common/tables/IocTable";

import useEnrichedIpUrls from "../hooks/useEnrichedIpUrls";
import { schema } from "./schema";

type Props = IP & {
  title?: string;
};

const RelatedUrlsCard = ({ ip, title }: Props) => {
  const { data, isPending, hasNextPage, fetchNextPage, isFetchingNextPage } =
    useEnrichedIpUrls({ ip });

  const entries = data?.pages?.flatMap(page => page?.reports ?? []) || [];

  const handleNextPage = () => {
    if (!hasNextPage || isFetchingNextPage) return;
    fetchNextPage();
  };

  return (
    <NetworkThreatCard
      header={
        <NetworkThreatCard.Header
          title={<CardTitle label={title ?? "Related URLs"} />}
        />
      }
      contentClassName="p-0 flex flex-center justify-content-center"
      content={
        <IocTable
          schema={schema}
          data={entries}
          isLoading={isPending}
          isFetchingNextPage={isFetchingNextPage}
          hasMore={hasNextPage}
          onNextPage={handleNextPage}
        />
      }
    />
  );
};

export default RelatedUrlsCard;
